import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Question from '../Question';

const IndividualLookup = ({
      headerTitle,
      familyNameId,
      familyNameLabel,
      arnId,
      arnLabel,
      existingAnswers,
      returnAnswer,
      showError}) => {

    return (
        <Fragment>
            <h4>{headerTitle}</h4>

            <Question
                id={familyNameId}
                type="text"
                label={familyNameLabel}
                stepid="addStudent"
                showError={showError}
                returnQuestionData={returnAnswer}
                existingAnswer={existingAnswers.familyName ? {value: existingAnswers.familyName} : null}
                />

            <Question
                id={arnId}
                type="number"
                label={arnLabel}
                stepid="addStudent"
                showError={showError}
                returnQuestionData={returnAnswer}
                existingAnswer={existingAnswers.arn ? {value: existingAnswers.arn} : null}
                />
        </Fragment>
    )
}

IndividualLookup.propTypes = {
    headerTitle: PropTypes.string.isRequired,
    familyNameLabel: PropTypes.string.isRequired,
    arnLabel: PropTypes.string.isRequired,
    returnAnswer: PropTypes.func.isRequired,
    existingAnswers: PropTypes.object,
    familyNameId: PropTypes.string,
    arnId: PropTypes.string,
    showError: PropTypes.bool
};

export default IndividualLookup;